import { FILE_MIME_TYPES } from "shared/lib/constants/files";

const PROFILE_PICTURE_ALLOWED_MIME_TYPES = Object.values(FILE_MIME_TYPES.IMAGE);

export const MAX_AVATAR_SIZE_MB = 10;

export const DROPZONE_ACCEPT = {
  "image/*": PROFILE_PICTURE_ALLOWED_MIME_TYPES,
};

export const SUPPORTED_AVATAR_FORMATS_LIST =
  PROFILE_PICTURE_ALLOWED_MIME_TYPES.join(", ");

export const SUPPORTED_AVATAR_FORMATS_READABLE_LIST =
  PROFILE_PICTURE_ALLOWED_MIME_TYPES.map((mime) =>
    mime.replace("image/", "")
  ).join(", ");

export const getPictureUploadValidationMessages = (maxSizeMb: number) => ({
  FORMAT: `Only ${SUPPORTED_AVATAR_FORMATS_LIST} formats are allowed`,
  SIZE: `Maximum file size is ${maxSizeMb}MB`,
  BOTH: `File size is too large (${maxSizeMb}MB max) and format is invalid (${SUPPORTED_AVATAR_FORMATS_LIST} formats are allowed)`,
});
